import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AgGridReact } from 'ag-grid-react'; // the AG Grid React Component
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import CampaignList from '../../assets/json/dummyDropDown.json';
import { Button, Modal } from 'react-bootstrap';
import AddCampaignForm from './addCampaignForm';
import ViewCampaigns from './viewCampaigns';
import {
  getActiveOwners,
  getCampaignList,
  getGenericMasterFilteredListByKey,
  getTagsByModule,
  getUser,
  getGridDataByModuleKey,
  getUserRole,
} from '../../redux/selector';
import {
  fetchDataAndUpdateStore,
  fetchRemainingData,
  fetchSelectedListAndAppendToModule,
} from '../../redux/actions';
import { useDispatch, useSelector } from 'react-redux';
import { isLoadingByKey } from '../../shared/controls/methods/getLoadingState';
import Loader from '../../shared/component/Loader';
import apiServices from '../../services/service';
import DeleteConfirmationModal from '../../shared/modal/deleteConfirmation';
import { DateFormatter, DateTimeFormatter, NameFormatter } from '../../shared/controls/formatters';
import Select from 'react-select';
import {
  dropdownPayloadCampaignContact,
  dropdownPayloadCampaignLead,
  filterParams,
  ticketInputData,
} from '../../shared/constants';
import Tags from '../sharedChild/tags';
import { validationSchemaCampaign } from './validationSchema';
import GlobalSearch from '../sharedChild/grid/globalSearch';
import FilterHandler from '../sharedChild/grid/filterHandler';
import ChildTicket from '../sharedChild/childTicket';
import smart from '../../../src/assets/img/crm_home/main-content/smart.png';
import campaigns from '../../../src/assets/img/crm_home/header/campaigns.png';
import SmartSequence from './smartSequence';
import ticket from '../../../src/assets/img/crm_home/header/ticket.png';
import gridOptionsConfig from '../sharedChild/grid/gridOptionsConfig';
import useFetchIfNeeded from '../../redux/useFetchIfNeeded';
import { TextBox } from '../../shared/controls/form';
import CampaignRegistrationPopup from '../sharedChild/campaignRegistrationPopup';

const OptionButton = ({
  handleOpenEditForm,
  paramsValue,
  handleOpenViewForm,
  handleClickDelete,
  rowData,
  hasDeleteCampaignPermission,
  hasUpdateCampaignPermission,
  hasInfoCampaignPermission,
}) => {
  const [showConfirmation, setShowConfirmation] = useState(false);

  const handleDeleteClick = (e) => {
    e.preventDefault();
    setShowConfirmation(true);
  };

  const handleConfirmDelete = () => {
    handleClickDelete(rowData);
    setShowConfirmation(false);
  };

  const handleCloseConfirmation = () => {
    setShowConfirmation(false);
  };

  return (
    <div className="action-menu">
      {hasUpdateCampaignPermission && (
        <img
          src="/assets/images/edit.png"
          className="action-img1"
          onClick={() => handleOpenEditForm(paramsValue)}
          alt="Edit Campaign"
          title="Edit Campaign"
        ></img>
      )}
      {hasInfoCampaignPermission && (
        <img
          src="/assets/images/view.png"
          className="action-img2"
          onClick={() => handleOpenViewForm(paramsValue)}
          alt="View Campaign"
          title="View Campaign"
        ></img>
      )}
      {hasDeleteCampaignPermission && (
        <img
          src="/assets/images/trash.png"
          className="action-img2"
          onClick={handleDeleteClick}
          alt="Delete Campaign"
          title="Delete Campaign"
        ></img>
      )}
      <DeleteConfirmationModal
        show={showConfirmation}
        handleClose={handleCloseConfirmation}
        handleConfirm={handleConfirmDelete}
        content={'campaign'}
      />
    </div>
  );
};
const campaignInputData = {
  pageSize: parseInt(process.env.REACT_APP_DEFAULT_PAGESIZE),
  pageNumber: 1,
  columnName: 'UpdatedDateTime',
  orderType: 'desc',
  filterJson: null,
};
function Campaigns() {
  const stateData = useSelector((state) => state);
  const dispatch = useDispatch();
  let storeLoading = isLoadingByKey(stateData, 'campaignList', 'tags', 'owners');
  useFetchIfNeeded(getCampaignList, fetchDataAndUpdateStore, {
    key: 'campaignList',
    inputData: campaignInputData,
  });
  const containerStyle = useMemo(() => ({ width: '100%', height: '100%' }), []);
  const [selectedTheme, setSelectedTheme] = useState('balham');
  const [loading, setLoading] = useState(storeLoading);
  const gridRef = useRef();
  const [open, setOpen] = React.useState(false);
  const [viewOpen, setViewOpen] = useState(false);
  // const userInformation = JSON.parse(localStorage.getItem('userInformation'));
  const userRole = useSelector(getUserRole);
  const role = userRole || '';
  const isSystemManager = role === 'System Manager';
  const rowData = useSelector(getCampaignList);
  const [campaignData, setCampaignData] = useState();
  const [activeMenu, setActiveMenu] = useState(null);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const [selectedRows, setSelectedRows] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [fieldValues, setFieldValues] = useState({});
  const [ownerFieldValues, setOwnerFieldValues] = useState({});
  const [selectedOption, setSelectedOption] = useState(null);
  const [isSelectedOption, setIsSelectedOption] = useState(false);
  const [allcolumnList, setAllcolumnList] = useState([]);
  const [popupAction, setPopupAction] = useState('add');
  const [remindVisible, setRemindVisible] = useState(false);
  const [showReminderPage, setShowReminderPage] = useState(false);
  const [formData, setFormData] = useState([]);
  const [errormsg, setErrorMsg] = useState({});
  const [formEdited, setFormEdited] = useState(false);
  const [filterJson, setfilterJson] = useState();
  const gridData = useSelector(getGridDataByModuleKey('campaignList'));
  const gridDataSelection = useSelector(getGridDataByModuleKey('selectionList'));
  const tagsList = useSelector(getTagsByModule('campaignList'));
  const [gridParams, setGridParams] = useState(null);
  const gridOptions = gridOptionsConfig('campaignList', navigate);
  const [showModal, setShowModal] = useState(false);

  let hasUpdateCampaignPermission = true;
  let hasCreateCampaignPermission = true;
  let hasDeleteCampaignPermission = true;
  let hasInfoCampaignPermission = true;
  let userUIControlPermission = JSON.parse(
    localStorage.getItem('userUIControlPermission')
  )?.campaignmenu;

  if (userUIControlPermission) {
    hasCreateCampaignPermission = userUIControlPermission?.campaignaddscreen
      ? userUIControlPermission.campaignaddscreen.canView
      : true;

    hasUpdateCampaignPermission = userUIControlPermission?.campaignupdatescreen
      ? userUIControlPermission.campaignupdatescreen.canView
      : true;

    hasDeleteCampaignPermission = userUIControlPermission?.campaigndeletescreen
      ? userUIControlPermission.campaigndeletescreen.canView
      : true;

    hasInfoCampaignPermission = userUIControlPermission?.campaigninfoscreen
      ? userUIControlPermission.campaigninfoscreen.canView
      : true;
  }

  const ticketPriorityDropdown = useSelector(
    getGenericMasterFilteredListByKey('TicketPriorityCrm')
  );
  const ticketStatusDropdown = useSelector(getGenericMasterFilteredListByKey('StatusCrm'));
  const memberStatus = useSelector(getGenericMasterFilteredListByKey('MemberStatusCrm'));
  const campaignType = useSelector(getGenericMasterFilteredListByKey('CampaignType'));
  const campaignStatus = useSelector(getGenericMasterFilteredListByKey('CampaignStatus'));
  const owner = useSelector(getActiveOwners);
  const userInfo = useSelector(getUser);
  const campaignListDropdown = useSelector(getCampaignList);

  useEffect(() => {
    const checkDomain = async () => {
      const data = {
        userEmailId: userInfo?.user?.email,
      };
      try {
        const response = await apiServices.isDomainExist(data);
        if (response?.data?.toString().toLowerCase() === 'false') {
          setShowModal(true);
        } else {
          console.log('Domain  exist.');
        }
      } catch (error) {
        console.error('Error checking domain:', error);
      }
    };

    checkDomain();
  }, []);

  const onSelectionChanged = (event) => {
    const gridApi = gridRef.current.api;
    const selectedRowsLocal = gridApi.getSelectedRows();
    const key = 'page-' + gridData?.inputPayload?.pageNumber;

    setSelectedRows(selectedRowsLocal);

    dispatch(
      fetchSelectedListAndAppendToModule({
        key: 'campaignList',
        selectedList: { [key]: selectedRowsLocal },
      })
    );
  };

  const fullSelection = Object.values(gridDataSelection?.campaignList || {}).flat();

  const location = useLocation();

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setActiveMenu(null);
    }
  };

  // const handleOpenModal = () => {
  //   setShowModal(true);
  // };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const handleGetMassPopup = () => {
    getAllColumns();
    setFieldValues({});
    setOwnerFieldValues((prevValues) => ({
      ...prevValues,
      ownerId: userInfo.user.userId,
    }));
    // setOwnerFieldValues({"ownerId":userInfo.user.userId});
    setIsSelectedOption(false);
    setSelectedOptions(null);
  };
  const handleAddTag = () => {
    setPopupAction('add');
    setShowPopup(true);
  };

  // When "Remove Tags" is clicked, set mode to "remove" and show the popup
  const handleRemoveTag = () => {
    setPopupAction('remove');
    setShowPopup(true);
  };
  const handleSelection = (selectedOption) => {
    setIsSelectedOption(true);
    // Clear previous field value
    setFieldValues({});
    if (selectedOption.originalData.headerName === 'Type') {
      selectedOption.originalData.data = campaignType;
    } else if (selectedOption.originalData.headerName === 'Campaign Owner') {
      selectedOption.originalData.data = owner;
    } else if (selectedOption.originalData.headerName === 'Status') {
      selectedOption.originalData.data = campaignStatus;
    }
    setSelectedOption(selectedOption); // Update the selected value in state
    console.log('Selected Option:', selectedOption); // Log the selected value
  };

  const handleInputChange = (e, fieldName) => {
    const value = e.target.value;
    // For other fields, directly update the state
    setFieldValues((prevValues) => ({
      ...prevValues,
      [fieldName]: value,
    }));
  };

  const handleDropdownChange = (selected, fieldName) => {
    const value = selected.value;
    setFieldValues((prevValues) => ({
      ...prevValues,
      [fieldName]: value,
    }));

    console.log(`Dropdown selected: ${value}`);
  };

  const handleSelectChange = (selectedOption) => {
    if (selectedOption) {
      // Format the selected data as required
      const formattedData = {
        fieldName: 'ownerId', // Static field name
        fieldValue: selectedOption.value, // The `value` from the dropdown
      };

      setOwnerFieldValues((prevValues) => ({
        ...prevValues,
        [formattedData.fieldName]: formattedData.fieldValue,
      }));
      // Log or handle the formatted JSON data
      console.log('Formatted Data:', formattedData);
    }
  };

  const handleChange = (selectedOption, name) => {
    setSelectedOptions((prevState) => ({
      ...prevState,
      [name]: selectedOption,
    }));
    handleLookupDropDownChange(selectedOption.value, selectedOption, name);
  };

  const handleLookupDropDownChange = (selectedId, selectedOption, name) => {
    const selectedValue = selectedOption.label;
    if (name === 'memberStatusId') {
      setCampaignData({
        ...campaignData,
        memberStatusId: selectedValue,
        memberStatus: selectedId,
      });
    } else if (name === 'campaignId') {
      setCampaignData({
        ...campaignData,
        campaignId: selectedId,
      });
    } else if (name === 'statusId') {
      setFormData({
        ...formData,
        statusId: selectedId,
        status: selectedValue,
      });
      setFormEdited(true);
    } else if (name === 'priorityId') {
      setFormData({
        ...formData,
        priorityId: selectedId,
        priority: selectedValue,
      });
      setFormEdited(true);
    } else if (name === 'ownerId') {
      setFormData({
        ...formData,
        ownerId: selectedId,
        owner: selectedValue,
      });
      setFormEdited(true);
    } else if (name === 'status') {
      setFormData({
        ...formData,
        status: selectedId,
        // owner: selectedValue,
      });
      setFormEdited(true);
    }
  };

  const handleMassUpdate = async (selectedRowData) => {
    setLoading(true); // Set loading state when starting mass update
    let result;

    console.log('selectedRowData', selectedRowData);

    // Extract the IDs from the selectedRowData array
    const ids = selectedRowData.map((item) => item.id);

    // Check if there is at least one field to update
    if (Object.keys(fieldValues).length > 0) {
      const [fieldName, fieldValue] = Object.entries(fieldValues)[0];

      // Validate the specific field using Yup's validateAt
      try {
        await validationSchemaCampaign.validateAt(fieldName, {
          [fieldName]: fieldValue,
        });
      } catch (error) {
        if (error.name === 'ValidationError') {
          toast.error(`Validation error in ${fieldName}: ${error.message}`, {
            position: 'top-right',
          });
          setLoading(false);
          return;
        }
      }

      // ✅ Custom logic: If fieldName is startDate, ensure it's not greater than endDate in selected rows
      if (fieldName === 'startDate') {
        const invalidRows = selectedRowData.filter((row) => {
          const start = new Date(fieldValue);
          const end = row?.endDate ? new Date(row.endDate) : null;
          return end && start > end;
        });

        if (invalidRows.length > 0) {
          toast.error('Start Date cannot be after End Date in some selected rows.', {
            position: 'top-right',
          });
          setLoading(false);
          return;
        }
      }

      result = {
        ids: ids,
        fieldName: fieldName.charAt(0).toUpperCase() + fieldName.slice(1),
        fieldValue: fieldValue.toString(),
      };
    } else {
      toast.error('No field values provided for update.', {
        position: 'top-right',
      });
      setLoading(false);
      return;
    }

    console.log('result:', result);
    console.log('Submitted Values:', fieldValues);

    try {
      const response = await apiServices.updateMultipleCampaignField(result);
      if (response.status === 200) {
        document.getElementById('massUpdateCancel').click();
        toast.success('Campaign Updated Successfully!', {
          position: 'top-right',
        });

        handleGetMassPopup();
        dispatch(
          fetchDataAndUpdateStore({
            key: 'campaignList',
            inputData: gridData?.inputPayload || campaignInputData,
          })
        );
        dispatch(
          fetchDataAndUpdateStore({
            key: 'campaignDropdownLead',
            inputData: dropdownPayloadCampaignLead,
          })
        );
        dispatch(
          fetchDataAndUpdateStore({
            key: 'campaignDropdownContact',
            inputData: dropdownPayloadCampaignContact,
          })
        );
      } else {
        setLoading(false);
        const errorMessages = [];
        for (const key in response.errors) {
          if (response.errors.hasOwnProperty(key)) {
            const messages = response.errors[key];
            errorMessages.push(...messages);
          }
        }
        errorMessages.forEach((errorMessage) => {
          toast.error(errorMessage, { position: 'top-right' });
        });
      }
    } catch (error) {
      toast.error('An unexpected error occurred.', {
        position: 'top-right',
      });
      setLoading(false);
    }
  };

  const handleOwnerUpdate = (fullSelection) => {
    setLoading(true);
    let result;
    console.log('selectedRowData', fullSelection);
    // Extract the IDs from the selectedRowData array
    const ids = fullSelection.map((item) => item.id);
    if (Object.keys(ownerFieldValues).length > 0) {
      const [fieldName, fieldValue] = Object.entries(ownerFieldValues)[0];
      result = {
        ids: ids,
        fieldName: fieldName.charAt(0).toUpperCase() + fieldName.slice(1),
        fieldValue: fieldValue,
      };
    }
    apiServices
      .updateMultipleCampaignField(result)
      .then((response) => {
        if (response.status === 200) {
          document.getElementById('ownerUpdateCancel').click();
          handleGetMassPopup();
          toast.success('Owner Updated Successfully!', {
            position: 'top-right',
          });
          // setUpdateListFlag(true)
          dispatch(
            fetchDataAndUpdateStore({
              key: 'campaignList',
              inputData: gridData?.inputPayload ? gridData?.inputPayload : campaignInputData,
            })
          );
        } else {
          setLoading(false);
          const errorMessages = [];
          for (const key in response.errors) {
            if (response.errors.hasOwnProperty(key)) {
              const messages = response.errors[key];
              errorMessages.push(...messages);
            }
          }
          errorMessages.forEach((errorMessage) => {
            toast.error(errorMessage, { position: 'top-right' });
          });
        }
      })

      .catch((error) => {
        toast.error('An unexpected error occurred.', {
          position: 'top-right',
        });
        setLoading(false);
      });
  };

  const handleSubmit = (campaignData) => {
    // Implement campaign submit logic
  };

  // Add this method to get all columns
  const getAllColumns = () => {
    const columnApi = gridRef.current.columnApi;
    const data = columnApi.api.getAllGridColumns();
    const excludedColumns = ['Campaign Owner', 'Campaign Name', 'Type', 'Description'];
    const allColumns = data
      .map((col) => col.getColDef())
      .filter((colDef) => excludedColumns.includes(colDef.headerName));
    setAllcolumnList(allColumns);
    // const allColumns = columnApi.getAllColumns();
    console.log('All Columns:', allColumns);
  };

  // Add custom styles for Select component
  const customStyles = {
    control: (base, state) => ({
      ...base,
      border: state.isFocused ? '2px solid transparent' : '1px solid transparent',
      borderRadius: '5px',
      boxShadow: state.isFocused ? 'none' : 'none',
      ':hover': {
        borderColor: 'transparent',
      },
    }),
    placeholder: (base) => ({
      ...base,
      color: '#888',
      fontSize: '.8rem',
    }),
    indicatorsContainer: (base) => ({
      ...base,
      display: 'none',
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: '#E7F2FF',
      borderRadius: '50px',
      padding: '5px 14px',
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: '#707070',
      fontSize: '.8rem',
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: '#4caf50',
      ':hover': {
        backgroundColor: '#d32f2f',
        color: '#fff',
      },
    }),
  };

  const isMobile = () => {
    return window.innerWidth <= 767;
  };
  const [columnDefs, setColumnDefs] = useState([]);

  const filterDefaultSetRef = useRef(null);

  const handleFilterChanged = useCallback(
    (event) => {
      if (filterDefaultSetRef.current) {
        filterDefaultSetRef.current = false;
      } else {
        let filterModel = event.api.getFilterModel();
        console.log('Original Filter Model:', filterModel);

        // Create mappings for campaign names and tag names to their IDs
        const campaignMapping = {};
        if (campaignListDropdown?.length) {
          campaignListDropdown.forEach((item) => {
            campaignMapping[item.campaignName] = item.id;
          });
        }

        const tagMapping = {};
        if (tagsList?.length) {
          tagsList.forEach((item) => {
            tagMapping[item.name] = item.id;
          });
        }

        const updatedFilterModel = Object.keys(filterModel).reduce((acc, dynamicFilterKey) => {
          let filterData = filterModel[dynamicFilterKey];
          if (dynamicFilterKey === 'campaignId') {
            // Convert campaign names to campaign IDs
            const idValues = filterData.values
              .map((name) => campaignMapping[name])
              .filter((id) => id !== undefined);

            if (idValues.length > 0) {
              acc[dynamicFilterKey] = {
                filterType: 'text',
                operator: 'OR',
                conditions: idValues.map((id) => ({
                  filterType: 'text',
                  type: 'contains',
                  filter: id, // Ensure we send ID, not name
                })),
              };
            }
          } else if (dynamicFilterKey === 'tagIds') {
            // Convert tag names to tag IDs
            const idValues = filterData.values
              .map((name) => tagMapping[name])
              .filter((id) => id !== undefined);

            if (idValues.length > 0) {
              acc[dynamicFilterKey] = {
                filterType: 'text',
                operator: 'OR',
                conditions: idValues.map((id) => ({
                  filterType: 'text',
                  type: 'contains',
                  filter: id, // Ensure we send ID, not name
                })),
              };
            }
          }
          // Keep Other Filters Unchanged
          else {
            acc[dynamicFilterKey] = filterData;
          }

          return acc;
        }, {});

        console.log('Updated Filter Model:', updatedFilterModel);

        const payload = {
          ...gridData?.inputPayload,
          filterJson: JSON.stringify(updatedFilterModel),
          pageNumber: 1, // Reset to first page on filter change
        };

        console.log('Filter Payload:', payload);

        dispatch(
          fetchDataAndUpdateStore({
            key: 'campaignList',
            inputData: payload,
          })
        );
      }
    },
    [dispatch, gridData?.inputPayload, campaignListDropdown]
  );

  const handleSortChanged = useCallback(
    (event) => {
      const sortModel = event.columnApi
        .getAllDisplayedColumns()
        .map((col) => ({
          colId: col.getColId(),
          sort: col.getSort(),
        }))
        .filter((col) => col.sort);

      console.log('Sort Model:', sortModel);
      const columnName = sortModel.length > 0 ? sortModel[0].colId : 'UpdatedDateTime';
      const orderType = sortModel.length > 0 ? sortModel[0].sort : 'desc';

      const payload = {
        ...gridData?.inputPayload,
        columnName,
        orderType,
        pageNumber: 1, // Reset to first page on sort change
      };

      dispatch(
        fetchDataAndUpdateStore({
          key: 'campaignList',
          inputData: payload,
        })
      );
    },
    [dispatch, gridData?.inputPayload]
  );

  const statusBar = useMemo(() => {
    return {
      statusPanels: [
        { statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'left' },
        { statusPanel: 'agTotalRowCountComponent', align: 'center' },
        { statusPanel: 'agFilteredRowCountComponent' },
        { statusPanel: 'agSelectedRowCountComponent' },
        { statusPanel: 'agAggregationComponent' },
      ],
    };
  }, []);

  const sideBar = useMemo(() => {
    return {
      toolPanels: [
        {
          id: 'columns',
          labelDefault: 'Columns',
          labelKey: 'columns',
          iconKey: 'columns',
          toolPanel: 'agColumnsToolPanel',
          minWidth: 225,
          width: 225,
          maxWidth: 225,
          toolPanelParams: {
            suppressPivotMode: true, // 👈 Hide Pivot Mode toggle
            suppressRowGroups: false, // ✅ Allow row grouping
            suppressValues: false, // ✅ Allow aggregation if needed
            suppressPivots: true, // 👈 Hide the pivot section for columns
          },
        },
        {
          id: 'filters',
          labelDefault: 'Filters',
          labelKey: 'filters',
          iconKey: 'filter',
          toolPanel: 'agFiltersToolPanel',
          minWidth: 180,
          maxWidth: 400,
          width: 250,
        },
      ],
      position: 'left',
      defaultToolPanel: 'none', //show off filter tab bydefault.
    };
  }, []);

  const popupParent = useMemo(() => {
    return document.body;
  }, []);

  const sortingOrder = useMemo(() => {
    return ['desc', 'asc', null];
  }, []);

  const defaultColDef = useMemo(() => ({
    sortable: true,
    editable: false,
    flex: 1,
    minWidth: 130,
    filter: true,
    resizable: true,
    enableValue: true,
    enableRowGroup: true,
    enablePivot: true,
  }));

  const autoGroupColumnDef = useMemo(() => {
    return {
      minWidth: 200,
      pinned: 'left',
    };
  }, []);

  const handleOpenAddForm = () => {
    // handleOpenModal()
    navigate('/campaigns/addCampaign');
  };

  const handleOpenEditForm = (paramsValue) => {
    navigate('/campaigns/editCampaign', {
      state: paramsValue,
    });
  };

  const handleClickDelete = (paramsValue) => {
    setLoading(true);

    // Creating the desired JSON object
    let data;
    // Creating the desired JSON object
    if (paramsValue.id === undefined) {
      const selectedIds = fullSelection.map((row) => row.id);
      data = { id: selectedIds };
    } else {
      data = {
        id: [paramsValue.id],
      };
    }
    apiServices
      .deleteCampaign(data)
      .then((response) => {
        if (response.status === 200) {
          if (paramsValue.id === undefined) {
            document.getElementById('massDeleteModal').click();
          }
          dispatch(
            fetchDataAndUpdateStore({
              key: 'campaignList',
              inputData: gridData?.inputPayload ? gridData?.inputPayload : campaignInputData,
            })
          );
          dispatch(
            fetchDataAndUpdateStore({
              key: 'campaignDropdownLead',
              inputData: dropdownPayloadCampaignLead,
            })
          );
          dispatch(
            fetchDataAndUpdateStore({
              key: 'campaignDropdownContact',
              inputData: dropdownPayloadCampaignContact,
            })
          );
          // setUpdateListFlag(true);
          setLoading(false);
          toast.success('Campaign Deleted Successfully!', {
            position: 'top-right',
          });
        } else {
          setLoading(false);
          toast.error('Error deleting record', {
            position: 'top-right',
          });
        }
      })
      .catch((error) => {
        console.error('Error deleting record:', error);
        setLoading(false);
      });
  };

  const handleOpenViewForm = (paramsValue) => {
    navigate(
      `/campaigns/viewCampaign?id=${paramsValue.id}&pageNo=${gridData?.inputPayload?.pageNumber}`,
      {
        state: paramsValue,
      }
    );
  };

  const onFirstDataRendered = useCallback((params) => {
    gridRef.current.api.paginationGoToPage();
    getAllColumns();
  }, []);

  const cellClickedListener = useCallback((event) => {}, []);
  const handleCloseAddForm = () => {
    setOpen(false);
  };
  const togglePopupVisibility = () => {
    setRemindVisible(!remindVisible);
    setShowReminderPage(false); // Reset to default page on close
  };

  const handleBackClick = () => {
    setShowReminderPage(false);

    setFormData((prev) => ({
      ...prev,
      showReminder: !!prev.reminder, // true if reminder exists, false otherwise
    }));
  };

  const handleDateTime = (e) => {
    const dataTime = e.target.value;
    setFormData({
      ...formData,
      reminder: dataTime,
    });
  };
  const handleReminderClick = () => {
    setShowReminderPage(!showReminderPage);
    // When turning off reminder, clear the reminder value
    if (showReminderPage) {
      setFormData({
        ...formData,
        reminder: '',
        showReminder: false,
      });
    } else {
      // When turning on, preserve existing reminder if any
      setFormData({
        ...formData,
        showReminder: true,
      });
    }
  };

  const handleFormSubmit = (formData) => {
    setLoading(true);
    const ids = fullSelection.map((item) => item.id);
    const updatedFormData = {
      ...formData,
      campaignId: ids.toString(),
    };
    apiServices
      .createTicketList(updatedFormData)
      .then((response) => {
        if (response.status === 200) {
          togglePopupVisibility();
          toast.success('Ticket created successfully!');
          dispatch(
            fetchDataAndUpdateStore({
              key: 'ticketList',
              inputData: ticketInputData,
            })
          );
          setFormData([]);
          setSelectedOptions(null);
          setLoading(false);
        } else {
          setLoading(false);
          const errorMessages = [];
          for (const key in response.errors) {
            if (response.errors.hasOwnProperty(key)) {
              const messages = response.errors[key];
              errorMessages.push(...messages);
            }
          }
          errorMessages.forEach((errorMessage) => {
            toast.error(errorMessage, { position: 'top-right' });
          });
        }
      })

      .catch((error) => {
        console.error('Error:', error, 'DataFormat:', formData);
        toast.error('An unexpected error occurred.', {
          position: 'top-right',
        });
        setLoading(false);
      });
  };
  const handleChangeForm = (e) => {
    const { name, value } = e.target;
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
    }));
    const convertedValue = value;
    setFormData({
      ...formData,
      [name]: convertedValue,
    });
    setFormEdited(true);
  };

  const exportAll = async () => {
    setLoading(true);

    const fetchData = {
      ...campaignInputData,
      pageSize: gridData?.totalCount,
      searchText: gridData?.inputPayload?.searchText ? gridData?.inputPayload?.searchText : null,
      filterJson: gridData?.inputPayload?.filterJson ? gridData?.inputPayload?.filterJson : null,
    };

    try {
      const response = await apiServices.exportAllCampaign(fetchData);

      if (response?.data && response.status === 200) {
        setLoading(false);
        if (response?.data.includes('Export initiated.')) {
          toast.warning(response?.data); // Show toast
          setLoading(false);
        } else {
          // Convert data to Blob for better handling
          const blob = new Blob([response.data], {
            type: 'text/csv;charset=utf-8;',
          });
          const url = URL.createObjectURL(blob);

          // Create and trigger download
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'Campaigns.csv');
          document.body.appendChild(link);
          link.click();

          // Cleanup
          document.body.removeChild(link);
          URL.revokeObjectURL(url); // Free memory
        }
      } else {
        console.error('No data received from API.');
        setLoading(false);
      }
    } catch (error) {
      console.error('Error exporting leads:', error);
      setLoading(false);
    }
  };

  const handleOpenManageTag = () => {
    navigate('/campaigns/manageTags', {
      state: { module: 'campaignList', moduleApi: 'Campaign' },
    });
  };

  const [isTabActive, setIsTabActive] = useState('campaigns');

  // const handleIsTabActive = (Tab) => {
  //   setIsTabActive(Tab); // Note the return of !prev

  //   console.log(!isTabActive); // or use a useEffect to log actual updated value
  // };

  useEffect(() => {
    if (location.pathname.includes('/smartSequence')) {
      setIsTabActive('smartSq');
    } else {
      setIsTabActive('campaigns');
    }
  }, [location.pathname]);

  const handleIsTabActive = (tab) => {
    if (tab === 'smartSq' && location.pathname !== '/campaigns/smartSequence') {
      navigate('/campaigns/smartSequence');
    } else if (tab === 'campaigns' && location.pathname !== '/campaigns') {
      navigate('/campaigns');
    }
    setIsTabActive(tab);
  };

  const handleCreateSequnce = () => {
    navigate('/campaigns/createSmartSequence');
  };

  const refresh = async () => {
    setLoading(true);
    try {
      await dispatch(
        fetchDataAndUpdateStore({
          key: 'campaignList',
          inputData: gridData?.inputPayload,
        })
      );
    } catch (error) {
      console.error('Error refreshing campaign list:', error);
      toast.error('Failed to refresh campaign list.', {
        position: 'top-right',
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Check if userInfo exists and if the owner field hasn't been set yet.
    if (userInfo && userInfo?.user?.userId && !formData.owner) {
      // Update formData with the userInfo.userId.
      setFormData((prevData) => ({
        ...prevData,
        owner: userInfo?.user?.display_name,
        ownerId: userInfo?.user?.userId,
      }));

      // Optionally, update the selectedOptions if your SelectBox uses that prop.
      // setSelectedOptions((prevOptions) => ({
      //   ...prevOptions,
      //   ownerId: userInfo.userId,
      // }));
    }
  }, [remindVisible]);

  useEffect(() => {
    setLoading(storeLoading);
  }, [storeLoading]);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const gridApi = gridRef?.current?.api;
    if (gridApi && tagsList?.length > 0) {
      const tagFilterInstance = gridApi.getFilterInstance('tagIds');
      if (tagFilterInstance) {
        const newTagValues = tagsList.map((item) => item.name);
        tagFilterInstance.setFilterValues(newTagValues);
      }
    }
  }, [tagsList]);

  useEffect(() => {
    if (
      //campaignListDropdown.length > 0 &&
      campaignType?.length > 0 &&
      // tagsList?.length > 0 &&
      campaignStatus?.length > 0 &&
      owner?.length > 0
    ) {
      setColumnDefs([
        {
          headerName: 'Actions',
          headerCheckboxSelection: (params) => params?.node && !params.node.group,
          checkboxSelection: (params) => params?.node && !params.node.group,
          cellRenderer: (params) => {
            if (!params?.node || params.node.group) return null;
            const paramsValue = { ...params.data, rowIndex: params.rowIndex };
            return (
              <OptionButton
                hasUpdateCampaignPermission={hasUpdateCampaignPermission}
                hasDeleteCampaignPermission={hasDeleteCampaignPermission}
                hasInfoCampaignPermission={hasInfoCampaignPermission}
                rowData={paramsValue}
                openPopup={open}
                handleOpenEditForm={() => handleOpenEditForm(paramsValue)}
                handleOpenViewForm={() => handleOpenViewForm(paramsValue)}
                handleClickDelete={() => handleClickDelete(paramsValue)}
              />
            );
          },
          maxWidth: 100,
          minWidth: 100,
          sortable: false,
          filter: false,
          pinned: true,
        },
        {
          headerName: 'Campaign Name',
          field: 'campaignName',
          type: 'text',
          cellRenderer: (params) => {
            if (!params.value) return null; // Handle empty or null values
            return (
              <Link
                to={`/campaigns/viewCampaign?id=${params?.data?.id}&pageNo=${gridData?.inputPayload?.pageNumber}`}
                state={params?.data}
                style={{ fontWeight: '600' }}
              >
                {params.value}
              </Link>
            );
          },
          filter: 'agTextColumnFilter',
          filterParams: {
            buttons: ['apply', 'reset'],
            closeOnApply: true,
            suppressAndOrCondition: true,
          },

          pinned: isMobile() ? null : 'left',
          minWidth: 180,
        },
        {
          headerName: 'Type',
          field: 'campaignType',
          type: 'dropdown',
          filter: 'agSetColumnFilter',
          filterParams: {
            values:
              campaignType && campaignType.length > 0
                ? campaignType.map((item) => item.displayName)
                : [],
            buttons: ['apply', 'reset'],
            closeOnApply: true,
            defaultToNothingSelected: true, // ✅ Unchecks all records by default
            applyButtonDisabled: (params) => params.filterModel.values.length === 0,
          },
        },
        {
          headerName: 'Schedule At',
          field: 'scheduledDateTime',
          type: 'date',
          filter: 'agDateColumnFilter',
          filterParams: filterParams,
          valueFormatter: DateTimeFormatter,
        },
        {
          headerName: 'Template Name',
          field: 'templateName',
          type: 'dropdown',
          filter: 'agTextColumnFilter',
          filterParams: {
            buttons: ['apply', 'reset'],
            closeOnApply: true,
            suppressAndOrCondition: true,
          },
        },
        {
          headerName: 'Status',
          field: 'campaignStatus',
          type: 'dropdown',
          filter: 'agSetColumnFilter',
          filterParams: {
            values:
              campaignStatus && campaignStatus.length > 0
                ? campaignStatus.map((item) => item.displayName)
                : [],
            buttons: ['apply', 'reset'],
            closeOnApply: true,
            defaultToNothingSelected: true, // ✅ Unchecks all records by default
            applyButtonDisabled: (params) => params.filterModel.values.length === 0,
          },
        },
        {
          headerName: 'Created By',
          field: 'createdBy',
          minWidth: 180,
          filter: 'agTextColumnFilter',
          filterParams: {
            buttons: ['apply', 'reset'],
            closeOnApply: true,
            suppressAndOrCondition: true,
          },
          valueFormatter: NameFormatter,
        },
        {
          headerName: 'Updated By',
          field: 'updatedBy',
          minWidth: 180,
          filter: 'agTextColumnFilter',
          filterParams: {
            buttons: ['apply', 'reset'],
            closeOnApply: true,
            suppressAndOrCondition: true,
          },
          valueFormatter: NameFormatter,
        },
        {
          headerName: 'Created Date Time(UTC)',
          field: 'createdDateTime',
          minWidth: 230,
          filter: 'agDateColumnFilter',
          filterParams: filterParams,
          valueFormatter: DateTimeFormatter,
          hide: true,
        },
        {
          headerName: 'Updated Date Time(UTC)',
          field: 'updatedDateTime',
          minWidth: 230,
          filter: 'agDateColumnFilter',
          filterParams: filterParams,
          valueFormatter: DateTimeFormatter,
          hide: true,
        },
        {
          headerName: 'Tags',
          field: 'tagIds',
          filter: 'agSetColumnFilter',
          valueGetter: (params) => params.data.tags,
          filterParams: {
            values: tagsList && tagsList.length > 0 ? tagsList.map((item) => item?.name[0]) : [],
            buttons: ['apply', 'reset'],
            closeOnApply: true,
            defaultToNothingSelected: true, // ✅ Unchecks all records by default
            applyButtonDisabled: (params) => params.filterModel.values.length === 0,
          },
          hide: true,
        },
        {
          headerName: 'Description',
          field: 'description',
          type: 'text',
          filter: 'agTextColumnFilter',
          filterParams: {
            buttons: ['apply', 'reset'],
            closeOnApply: true,
            suppressAndOrCondition: true,
          },
          hide: true,
        },
        {
          headerName: 'Campaign Owner',
          field: 'owner',
          type: 'dropdown',
          filter: 'agSetColumnFilter',
          filterParams: {
            values: owner && owner.length > 0 ? owner.map((item) => item.display_name) : [],
            buttons: ['apply', 'reset'],
            closeOnApply: true,
            defaultToNothingSelected: true, // ✅ Unchecks all records by default
            applyButtonDisabled: (params) => params.filterModel.values.length === 0,
          },
        },
      ]);
    }
  }, [loading, campaignType, campaignStatus, owner]);

  useEffect(() => {
    if (
      gridRef.current?.api &&
      gridData?.campaign?.length &&
      //campaignListDropdown?.length ||
      tagsList?.length &&
      gridData?.inputPayload?.filterJson
    ) {
      try {
        // Parse filterJson
        const filterJson = JSON.parse(gridData.inputPayload.filterJson);

        // Extract tag IDs
        const tagIds = filterJson?.tagIds?.conditions
          ? filterJson.tagIds.conditions.map((condition) => condition.filter)
          : filterJson?.tagIds?.filter
            ? [filterJson.tagIds.filter]
            : [];
        setfilterJson(filterJson);

        //Create a mapping of tagId -> tagName
        const tagMapping = tagsList.reduce((acc, tag) => {
          acc[tag.id] = tag.name;
          return acc;
        }, {});

        // Get tag names from matched IDs (flattened)
        const matchedTagNames = tagIds.map((id) => tagMapping[id] || 'Unknown Tag').flat();

        // Update contacts with campaignName and tags
        const updatedCampaigns = gridData.campaign.map((campaign) => ({
          ...campaign,
          tags: matchedTagNames, // Flattened array
        }));

        // Update grid data
        const updatedGridData = {
          ...gridData,
          campaign: updatedCampaigns,
        };
        console.log('🚀 ~ useEffect ~ updatedGridData:', updatedGridData);

        // Update the grid with new data
        gridRef.current.api.setGridOption('rowData', updatedGridData.campaign);
        gridRef.current.api.refreshCells();
      } catch (error) {
        console.error('Error parsing filterJson:', error);
      }
    }
  }, [gridData]);

  useEffect(() => {
    if (!formData?.reminder) {
      setShowReminderPage(false);
      setFormData((prev) => ({
        ...prev,
        showReminder: false,
      }));
    }
  }, [formData?.reminder]);

  useEffect(() => {
    if (location.state?.activeTab === 'smartSq') {
      setIsTabActive('smartSq');
    }
  }, [location.state]);

  useFetchIfNeeded(getTagsByModule('campaignList'), fetchDataAndUpdateStore, {
    key: 'tagsByModule',
    inputData: 'Campaign',
    storeKey: 'campaignList',
  });

  return (
    <>
      {open ? (
        <AddCampaignForm
          handleCloseAddForm={handleCloseAddForm}
          handleOpenEditForm={handleOpenEditForm}
          campaignData={campaignData}
          open={open}
          campaignList={CampaignList}
        />
      ) : showModal ? (
        <CampaignRegistrationPopup showModal={showModal} handleCloseModal={handleCloseModal} />
      ) : (
        <div className="inner-page" style={containerStyle}>
          <div className="dash-container">
            <div className="tbl_container">
              <div className="row">
                <div className="col-12 col-sm-12 col-md-12">
                  <div className="main-hd tabP">
                    <div className="mob">
                      <div className="pagetitle">
                        <img src="../assets/images/role-management-icons/left-arrow.png" alt="" />
                        {isTabActive === 'campaigns' ? 'Campaigns' : 'Smart Sequence'}
                      </div>
                    </div>
                    <div className="dsk">
                      <div className="pagetitle tabLeft">
                        <div className="nav nav-tabs" id="nav-tab" role="tablist">
                          <button
                            className={`nav-link ${isTabActive === 'campaigns' ? 'active' : ''}`}
                            id="campaigns-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#campaigns"
                            type="button"
                            role="tab"
                            aria-controls="campaigns"
                            aria-selected="true"
                            onClick={() => {
                              handleIsTabActive('campaigns');
                            }}
                          >
                            <img src={campaigns} alt="Campaings" />
                            Campaigns
                          </button>
                          {isSystemManager && (
                            <button
                              className={`nav-link ${isTabActive === 'smartSq' ? 'active' : ''}`}
                              id="smartSq-tab"
                              data-bs-toggle="tab"
                              data-bs-target="#smartSq"
                              type="button"
                              role="tab"
                              aria-controls="smartSq"
                              aria-selected="true"
                              onClick={() => {
                                handleIsTabActive('smartSq');
                              }}
                            >
                              <img src={smart} alt="Smart Sequence" />
                              Smart Sequence
                            </button>
                          )}
                        </div>
                      </div>
                    </div>

                    {isTabActive === 'campaigns' ? (
                      <>
                        {fullSelection.length > 0 ? (
                          <>
                            <div className="third-div mobView tabAction">
                              <div className="dsk">
                                <GlobalSearch
                                  moduleName={'campaignList'}
                                  fullSelection={fullSelection}
                                />
                              </div>
                              <div className="heading_item topLink" id="createtask_dropdown">
                                <Link
                                  href="#"
                                  className="task_btn hd-btn"
                                  onClick={togglePopupVisibility}
                                >
                                  <img
                                    src={ticket}
                                    alt="Create Ticket"
                                    className="me-2"
                                    style={{ width: '14px', height: '14px' }}
                                  />
                                  <span className="btnText">Create Ticket</span>
                                </Link>
                              </div>
                              <div className="heading_item topLink" id="tags_dropdown">
                                <div className="dropdown">
                                  <button
                                    className=" btn action-btn dropdown-toggle"
                                    type="button"
                                    id="dropdownMenuButton"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    Tags
                                  </button>
                                  <ul
                                    className="dropdown-menu"
                                    aria-labelledby="dropdownMenuButton"
                                  >
                                    <li>
                                      <Link className="dropdown-item" onClick={handleAddTag}>
                                        Add Tags
                                      </Link>
                                    </li>
                                    <li>
                                      <Link className="dropdown-item" onClick={handleRemoveTag}>
                                        Remove Tags
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                              <div className="heading_item topLink" id="actiongrid_dropdown">
                                <div className="dropdown">
                                  <button
                                    className="btn action-btn dropdown-toggle "
                                    type="button"
                                    id="dropdownMenuButton"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    Actions
                                  </button>

                                  <ul
                                    className="dropdown-menu"
                                    aria-labelledby="dropdownMenuButton"
                                  >
                                    <li
                                      className="dropdown-item"
                                      data-bs-toggle="modal"
                                      data-bs-target="#myModal"
                                      onClick={() => handleGetMassPopup()}
                                    >
                                      Mass Update
                                    </li>
                                    <li
                                      className="dropdown-item"
                                      data-bs-toggle="modal"
                                      data-bs-target="#myOwner"
                                      onClick={() => handleGetMassPopup()}
                                    >
                                      Change Owner
                                    </li>
                                    {/* <li
                                    className="dropdown-item"
                                    data-bs-toggle="modal"
                                    data-bs-target="#delete"
                                  >
                                    Delete
                                  </li> */}
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="third-div mobView tabAction">
                              <div className="position-relative">
                                <i
                                  className="bi bi-arrow-repeat"
                                  title="Refresh Campaign Status"
                                  style={{ color: 'blue', cursor: 'pointer' }}
                                  onClick={refresh}
                                  data-tooltip-id="refresh-tooltip"
                                  data-tooltip-content="Refresh Campaign Status"
                                ></i>
                              </div>
                              <div className="dsk">
                                <GlobalSearch
                                  moduleName={'campaignList'}
                                  fullSelection={fullSelection}
                                />
                              </div>
                              <div className="heading_item" id="actiongrid_dropdown">
                                <div className="dropdown">
                                  <button
                                    className="btn action-btn mobOption dropdown-toggle "
                                    type="button"
                                    id="dropdownMenuButton"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    <div className="mob">
                                      <i className="bi bi-three-dots"></i>
                                    </div>{' '}
                                    <div className="dsk">Options</div>
                                  </button>

                                  <ul
                                    className="dropdown-menu"
                                    aria-labelledby="dropdownMenuButton"
                                  >
                                    <li className="dropdown-item" onClick={handleOpenManageTag}>
                                      Manage Tags
                                    </li>
                                    {/* <li className="dropdown-item">Deduplicate Leads</li> */}
                                    <li
                                      className="dropdown-item"
                                      onClick={exportAll}
                                      disabled={rowData && rowData.length === 0}
                                    >
                                      Export Campaigns
                                    </li>
                                  </ul>
                                </div>
                              </div>

                              {hasCreateCampaignPermission && (
                                <div className="btn-group" id="timelogdropdown">
                                  <button
                                    className="timelog-btn"
                                    type="button"
                                    onClick={handleOpenAddForm}
                                  >
                                    Create Campaign
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-primary dropdown-toggle dropdown-toggle-split"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    <span className="visually-hidden">Toggle Dropdown</span>
                                  </button>
                                  <ul className="dropdown-menu dropdown-menu-end">
                                    <li className="dropdown-item">
                                      <Link to="/campaigns/importCampaign">Import Campaigns</Link>
                                    </li>
                                  </ul>
                                </div>
                              )}
                            </div>
                          </>
                        )}
                      </>
                    ) : (
                      <div className="third-div mobView tabAction">
                        <div className="dsk">
                          <GlobalSearch moduleName={'campaignList'} fullSelection={fullSelection} />
                        </div>
                        <button
                          onClick={exportAll}
                          className="btn btn-outline-primary mobOption export-btn"
                          type="button"
                          disabled={rowData && rowData.length === 0}
                        >
                          <svg
                            width="16px"
                            height="16px"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12 5L11.2929 4.29289L12 3.58579L12.7071 4.29289L12 5ZM13 14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14L13 14ZM6.29289 9.29289L11.2929 4.29289L12.7071 5.70711L7.70711 10.7071L6.29289 9.29289ZM12.7071 4.29289L17.7071 9.29289L16.2929 10.7071L11.2929 5.70711L12.7071 4.29289ZM13 5L13 14L11 14L11 5L13 5Z"
                              fill="#333333"
                            />
                            <path
                              d="M5 16L5 17C5 18.1046 5.89543 19 7 19L17 19C18.1046 19 19 18.1046 19 17V16"
                              stroke="#333333"
                              strokeWidth="2"
                            />
                          </svg>{' '}
                          <div className="dsk"> Export</div>
                        </button>

                        {hasCreateCampaignPermission && (
                          <button
                            className="btn btn-primary createTkt"
                            type="button"
                            onClick={handleCreateSequnce}
                          >
                            Create Sequence
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                  <div className="mob mb-3 ">
                    <GlobalSearch moduleName={'campaignList'} fullSelection={fullSelection} />
                  </div>

                  <div className="mob my-2 tabMob">
                    <div className=" pagetitle tabLeft">
                      <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        <button
                          className={`nav-link ${isTabActive === 'campaigns' ? 'active' : ''}`}
                          id="campaigns-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#campaigns"
                          type="button"
                          role="tab"
                          aria-controls="campaigns"
                          aria-selected="true"
                          onClick={() => {
                            handleIsTabActive('campaigns');
                          }}
                        >
                          <img src={campaigns} alt="Campaings" />
                          Campaigns
                        </button>
                        <button
                          className={`nav-link ${isTabActive === 'smartSq' ? 'active' : ''}`}
                          id="smartSq-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#smartSq"
                          type="button"
                          role="tab"
                          aria-controls="smartSq"
                          aria-selected="true"
                          onClick={() => {
                            handleIsTabActive('smartSq');
                          }}
                        >
                          <img src={smart} alt="Smart Sequence" />
                          Smart Sequence
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="tabPage">
                    <div className="tab-content" id="nav-tabContent">
                      {isTabActive === 'campaigns' ? (
                        // <div
                        //   className="tab-pane fade show active"
                        //   id="campaigns"
                        //   role="tabpanel"
                        //   aria-labelledby="campaigns-tab"
                        // >
                        <div className="cutome_ag_theme">
                          {loading && <Loader />}
                          <div
                            className={`ag-theme-${selectedTheme} tbl_height`}
                            style={{ width: '100%', height: `100%` }}
                          >
                            <AgGridReact
                              className="ag-grid-container" // Add a class for styling
                              domLayout="fixedHeight"
                              ref={gridRef} // Ref for accessing Grid's API
                              rowData={rowData} // Row Data for Row
                              columnDefs={columnDefs}
                              autoGroupColumnDef={autoGroupColumnDef}
                              defaultColDef={defaultColDef} // Default Column Properties
                              overlayLoadingTemplate={`<Loader />`}
                              animateRows={true} // Optional - set to 'true' to have rows animate when sorted
                              rowSelection={'multiple'} // Options - allows click selection of rows
                              sideBar={sideBar} // pass side by making interface
                              enableRangeSelection={true}
                              suppressExcelExport={true}
                              suppressRowClickSelection={true}
                              groupSelectsChildren={true}
                              pivotPanelShow={'always'}
                              popupParent={popupParent}
                              sortingOrder={sortingOrder}
                              onFirstDataRendered={onFirstDataRendered}
                              onCellClicked={cellClickedListener} // Optional - registering for Grid Event
                              rowDragManaged={true}
                              suppressMoveWhenRowDragging={true}
                              rowGroupPanelShow={'always'}
                              onSelectionChanged={onSelectionChanged}
                              onFilterChanged={handleFilterChanged}
                              gridOptions={gridOptions}
                              onSortChanged={handleSortChanged}
                              onGridReady={(params) => setGridParams(params)}
                            />
                            {gridParams && (
                              <FilterHandler
                                params={gridParams}
                                gridData={gridData}
                                campaignListDropdown={campaignListDropdown}
                                tagsList={tagsList}
                                columnDefs={columnDefs}
                                filterDefaultSetRef={filterDefaultSetRef}
                              />
                            )}
                          </div>
                        </div>
                      ) : (
                        // </div>
                        // <div
                        //   className="tab-pane fade"
                        //   id="smartSq"
                        //   role="tabpanel"
                        //   aria-labelledby="smartSq-tab"
                        // >
                        <SmartSequence />
                        // </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <CampaignRegistrationPopup showModal={showModal} handleCloseModal={handleCloseModal}/> */}
            <div id="dropdown_modal">
              <div
                className="modal fade"
                id="myModal"
                tabIndex="-1"
                aria-labelledby="modalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header" style={{ padding: '1rem 1.6rem' }}>
                      <h5 className="modal-title" id="modalLabel">
                        Mass Update
                      </h5>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body">
                      <div className="row">
                        <div className="col-12 col-md-6">
                          <div className="input-container">
                            <>
                              <label htmlFor="timeZoneId">Field</label>
                              <Select
                                value={isSelectedOption ? selectedOption : null}
                                options={allcolumnList?.map((data) => ({
                                  value: data.field,
                                  label: data.headerName,
                                  originalData: data,
                                }))}
                                onChange={(selectedOption) => handleSelection(selectedOption)}
                                menuShouldScrollIntoView={false}
                                disabled={'timeZoneId'}
                                placeholder={'Select Field'}
                                styles={{
                                  control: (base, state) => ({
                                    ...base,
                                    borderRadius: '5px',
                                    borderColor: state.isFocused ? '#365397' : base.borderColor,
                                    boxShadow: state.isFocused
                                      ? '0 0 0 1px #365397'
                                      : base.boxShadow,
                                  }),
                                  menu: (base) => ({
                                    ...base,
                                    borderRadius: '5px',
                                    zIndex: 99999,
                                  }),
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                  option: (base, state) => ({
                                    ...base,
                                    backgroundColor: state.isSelected
                                      ? 'rgba(54, 83, 151, 0.3)'
                                      : state.isFocused
                                        ? '#365397'
                                        : base.backgroundColor,
                                    color: state.isSelected
                                      ? '#fff'
                                      : state.isFocused
                                        ? '#fff'
                                        : base.color,
                                    cursor: 'pointer',
                                  }),
                                }}
                                menuPortalTarget={document.body}
                              />
                            </>
                          </div>
                        </div>
                        <div className="col-12 col-md-6">
                          <div className="input-container massInput">
                            <label></label>
                            {selectedOption && isSelectedOption ? (
                              selectedOption.originalData.type === 'text' ? (
                                <input
                                  type="text"
                                  placeholder={`Enter ${selectedOption.label}`}
                                  value={fieldValues[selectedOption.value] || ''}
                                  onChange={(e) => handleInputChange(e, selectedOption.value)}
                                  style={{
                                    width: '100%',
                                    height: '40px',
                                    borderRadius: '5px',
                                    //backgroundColor: "#f0f0f0",
                                    border: '1px solid #ccc', // Matches Select border color
                                    padding: '8px 12px', // Matches Select padding
                                    marginTop: '14px',
                                    fontSize: '16px',
                                    outline: 'none',
                                    transition: 'border-color 0.3s, box-shadow 0.3s',
                                  }}
                                  onFocus={(e) => {
                                    e.target.style.borderColor = '#365397'; // Focus border color
                                    e.target.style.boxShadow = '0 0 0 1px #365397'; // Focus box-shadow
                                  }}
                                  onBlur={(e) => {
                                    e.target.style.borderColor = '#ccc'; // Reset border color on blur
                                    e.target.style.boxShadow = 'none'; // Remove box-shadow on blur
                                  }}
                                />
                              ) : selectedOption.originalData.type === 'date' ? (
                                <input
                                  type="date"
                                  value={fieldValues[selectedOption.value] || ''}
                                  onChange={(e) => handleInputChange(e, selectedOption.value)}
                                  style={{
                                    width: '100%',
                                    height: '40px',
                                    borderRadius: '5px',
                                    border: '1px solid #ccc',
                                    padding: '8px 12px',
                                    marginTop: '14px',
                                    fontSize: '16px',
                                    outline: 'none',
                                    transition: 'border-color 0.3s, box-shadow 0.3s',
                                  }}
                                />
                              ) : selectedOption.originalData.type === 'dropdown' ? (
                                <Select
                                  value={
                                    fieldValues[`${selectedOption?.value}Id`] // Check if there's a value in the state for the selected option
                                      ? {
                                          value: fieldValues[`${selectedOption?.value}Id`],
                                          label:
                                            selectedOption.originalData.data?.find(
                                              (data) =>
                                                data.id ===
                                                  fieldValues[`${selectedOption?.value}Id`] ||
                                                (data.userId &&
                                                  data.userId ===
                                                    fieldValues[`${selectedOption?.value}Id`]) // Check both `id` and `userId` properly
                                            )?.displayName ||
                                            selectedOption.originalData.data?.find(
                                              (data) =>
                                                data.id ===
                                                  fieldValues[`${selectedOption?.value}Id`] ||
                                                (data.userId &&
                                                  data.userId ===
                                                    fieldValues[`${selectedOption?.value}Id`])
                                            )?.display_name ||
                                            '',
                                        }
                                      : null // If no value, set null to reset
                                  }
                                  options={
                                    selectedOption.originalData.data?.map((data) => ({
                                      value: data.id ? data.id : data.userId,
                                      label: data.displayName
                                        ? data.displayName
                                        : data.display_name,
                                    })) || []
                                  }
                                  disabled
                                  placeholder={`Select ${selectedOption.label}`}
                                  menuPortalTarget={document.body} // Ensures the dropdown renders outside the modal
                                  styles={{
                                    control: (base, state) => ({
                                      ...base,
                                      borderRadius: '5px',
                                      marginTop: '14px',
                                      borderColor: state.isFocused ? '#365397' : base.borderColor,
                                      boxShadow: state.isFocused
                                        ? '0 0 0 1px #365397'
                                        : base.boxShadow,
                                    }),
                                    menu: (base) => ({
                                      ...base,
                                      borderRadius: '5px',
                                      zIndex: 99999,
                                    }),
                                    menuPortal: (base) => ({
                                      ...base,
                                      zIndex: 99999,
                                    }),
                                    option: (base, state) => ({
                                      ...base,
                                      backgroundColor: state.isFocused
                                        ? '#365397'
                                        : base.backgroundColor,
                                      color: state.isFocused ? '#fff' : base.color,
                                      cursor: 'pointer',
                                    }),
                                    singleValue: (base) => ({
                                      ...base,
                                      padding: '2px 4px',
                                      borderRadius: '3px',
                                    }),
                                  }}
                                  onChange={(selected) =>
                                    handleDropdownChange(selected, `${selectedOption.value}Id`)
                                  }
                                />
                              ) : selectedOption.originalData.type === 'number' ? (
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    marginTop: '14px',
                                    position: 'relative',
                                  }}
                                >
                                  {/* Input wrapper with relative position */}
                                  {selectedOption.originalData.headerName === 'Annual Revenue' && (
                                    <div
                                      style={{
                                        position: 'relative',
                                        width: '100%',
                                      }}
                                    >
                                      {/* Dollar symbol inside the input box */}
                                      <span
                                        style={{
                                          position: 'absolute',
                                          left: '10px',
                                          top: '50%',
                                          transform: 'translateY(-50%)',
                                          fontSize: '16px',
                                          color: '#888',
                                          pointerEvents: 'none',
                                        }}
                                      >
                                        $
                                      </span>
                                      <input
                                        type="number"
                                        placeholder={`Enter ${selectedOption.label}`}
                                        value={fieldValues[selectedOption.value] || ''}
                                        onChange={(e) => {
                                          // Enforce number limit conditionally for "Mobile"
                                          const value = e.target.value;
                                          if (
                                            selectedOption.originalData.headerName === 'Mobile' &&
                                            value.length > 15
                                          ) {
                                            return; // Prevent further input if length exceeds limit
                                          }
                                          handleInputChange(e, selectedOption.value); // Call your change handler
                                        }}
                                        style={{
                                          width: '100%',
                                          height: '40px',
                                          borderRadius: '5px',
                                          border: '1px solid #ccc',
                                          padding: '8px 12px 8px 30px', // Add padding-left to account for the dollar symbol
                                          fontSize: '16px',
                                          outline: 'none',
                                          transition: 'border-color 0.3s, box-shadow 0.3s',
                                        }}
                                        onFocus={(e) => {
                                          e.target.style.borderColor = '#365397';
                                          e.target.style.boxShadow = '0 0 0 1px #365397';
                                        }}
                                        onBlur={(e) => {
                                          e.target.style.borderColor = '#ccc';
                                          e.target.style.boxShadow = 'none';
                                        }}
                                      />
                                    </div>
                                  )}
                                  {/* Input without the dollar sign for other cases */}
                                  {selectedOption.originalData.headerName !== 'Annual Revenue' && (
                                    <input
                                      type="number"
                                      placeholder={`Enter ${selectedOption.label}`}
                                      value={fieldValues[selectedOption.value] || ''}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        if (
                                          selectedOption.originalData.headerName === 'Mobile' &&
                                          value.length > 15
                                        ) {
                                          return;
                                        }
                                        handleInputChange(e, selectedOption.value);
                                      }}
                                      style={{
                                        width: '100%',
                                        height: '40px',
                                        borderRadius: '5px',
                                        border: '1px solid #ccc',
                                        padding: '8px 12px',
                                        fontSize: '16px',
                                        outline: 'none',
                                        transition: 'border-color 0.3s, box-shadow 0.3s',
                                      }}
                                      onFocus={(e) => {
                                        e.target.style.borderColor = '#365397';
                                        e.target.style.boxShadow = '0 0 0 1px #365397';
                                      }}
                                      onBlur={(e) => {
                                        e.target.style.borderColor = '#ccc';
                                        e.target.style.boxShadow = 'none';
                                      }}
                                    />
                                  )}
                                </div>
                              ) : (
                                <></>
                              )
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="cancel_popup"
                        id="massUpdateCancel"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="save_popup"
                        onClick={() => handleMassUpdate(fullSelection)}
                        disabled={loading}
                      >
                        Submit
                        {loading && (
                          <span
                            className="spinner-border spinner-border-sm ms-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Modal structure Change Owner */}
            <div id="dropdown_modal">
              <div
                className="modal fade"
                id="myOwner"
                tabIndex="-1"
                aria-labelledby="modalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header" style={{ padding: '1rem 1.6rem' }}>
                      <h5 className="modal-title" id="modalLabel">
                        Change Owner
                      </h5>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body">
                      <div className="row">
                        <div className="col-12 col-md-6" id="ownermodal">
                          <div className="input-container">
                            <label htmlFor="timeZoneId">Campaign Owner</label>
                            <Select
                              value={
                                owner
                                  ?.map((data) => ({
                                    value: data.userId,
                                    label: data.display_name,
                                  }))
                                  .find((option) => option.value === ownerFieldValues.ownerId) ||
                                null
                              }
                              options={owner?.map((data) => ({
                                value: data.userId,
                                label: data.display_name,
                              }))}
                              menuShouldScrollIntoView={false}
                              placeholder={userInfo?.user?.display_name}
                              onChange={handleSelectChange}
                              styles={{
                                control: (base, state) => ({
                                  ...base,
                                  borderRadius: '5px',
                                  borderColor: state.isFocused ? '#365397' : base.borderColor,
                                  boxShadow: state.isFocused ? '0 0 0 1px #365397' : base.boxShadow,
                                }),
                                menu: (base) => ({
                                  ...base,
                                  borderRadius: '5px',
                                  zIndex: 99999,
                                }),
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                                option: (base, state) => ({
                                  ...base,
                                  backgroundColor: state.isSelected
                                    ? 'rgba(54, 83, 151, 0.3)'
                                    : state.isFocused
                                      ? '#365397'
                                      : base.backgroundColor,
                                  color: state.isSelected
                                    ? '#fff'
                                    : state.isFocused
                                      ? '#fff'
                                      : base.color,
                                  cursor: 'pointer',
                                }),
                              }}
                              menuPortalTarget={document.body}
                              components={{
                                DropdownIndicator: (props) => (
                                  <div
                                    {...props.innerProps}
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                    }}
                                  >
                                    <svg
                                      width="18"
                                      height="20"
                                      viewBox="0 0 18 20"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M16.3334 18.25V16.4167C16.3334 15.4442 15.9471 14.5116 15.2595 13.8239C14.5718 13.1363 13.6392 12.75 12.6667 12.75H5.33341C4.36095 12.75 3.42832 13.1363 2.74069 13.8239C2.05306 14.5116 1.66675 15.4442 1.66675 16.4167V18.25M12.6667 5.41667C12.6667 7.44171 11.0251 9.08333 9.00008 9.08333C6.97504 9.08333 5.33341 7.44171 5.33341 5.41667C5.33341 3.39162 6.97504 1.75 9.00008 1.75C11.0251 1.75 12.6667 3.39162 12.6667 5.41667Z"
                                        stroke="#9B9B9B"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  </div>
                                ),
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer justify-content-end">
                      <button
                        type="button"
                        className="cancel_popup"
                        data-bs-dismiss="modal"
                        id="ownerUpdateCancel"
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="save_popup "
                        onClick={() => handleOwnerUpdate(fullSelection)}
                        disabled={loading}
                      >
                        {loading && (
                          <span
                            className="spinner-border spinner-border-sm ms-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        )}
                        Change Owner
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Modal structure Add To Campaigns */}
            <div id="dropdown_modal">
              <div
                className="modal fade"
                id="existing"
                tabIndex="-1"
                aria-labelledby="modalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header" style={{ padding: '1rem 1.6rem' }}>
                      <h5 className="modal-title" id="modalLabel">
                        Add to Campaigns
                      </h5>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        id="closeModalButton"
                      ></button>
                    </div>
                    <div className="modal-body">
                      <div className="row">
                        <div className="col-12 col-md-12" id="myexisting">
                          <div className="input-container">
                            <label htmlFor="timeZoneId">Assign Campaign</label>
                            <Select
                              value={selectedOptions?.campaignId}
                              onChange={(selectedOption) =>
                                handleChange(selectedOption, 'campaignId')
                              }
                              options={campaignListDropdown?.map((data) => ({
                                value: data.id,
                                label: data.campaignName,
                              }))}
                              menuShouldScrollIntoView={false}
                              placeholder={'Select Campaign'}
                              styles={{
                                control: (base, state) => ({
                                  ...base,
                                  borderRadius: '5px',
                                  borderColor: state.isFocused ? '#365397' : base.borderColor,
                                  boxShadow: state.isFocused ? '0 0 0 1px #365397' : base.boxShadow,
                                }),
                                menu: (base) => ({
                                  ...base,
                                  borderRadius: '5px',
                                  zIndex: 99999,
                                }),
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                                option: (base, state) => ({
                                  ...base,
                                  backgroundColor: state.isSelected
                                    ? 'rgba(54, 83, 151, 0.3)'
                                    : state.isFocused
                                      ? '#365397'
                                      : base.backgroundColor,
                                  color: state.isSelected
                                    ? '#fff'
                                    : state.isFocused
                                      ? '#fff'
                                      : base.color,
                                  cursor: 'pointer',
                                }),
                              }}
                              menuPortalTarget={document.body}
                              components={{
                                DropdownIndicator: (props) => (
                                  <div
                                    {...props.innerProps}
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                    }}
                                  >
                                    <svg
                                      width="20"
                                      height="16"
                                      viewBox="0 0 20 16"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M0.694444 3.83398C0.310926 3.83398 0 4.12572 0 4.48556V9.5713C0 9.93114 0.310926 10.2229 0.694444 10.2229C1.07796 10.2229 1.38889 9.93114 1.38889 9.5713V4.48556C1.38889 4.12572 1.07796 3.83398 0.694444 3.83398Z"
                                        fill="#9B9B9B"
                                      />
                                      <path
                                        d="M14.0917 0.222656H11.4687C11.1205 0.222656 10.8382 0.504721 10.8382 0.85264V1.42173L2.39558 3.92343C2.12793 4.00273 1.94434 4.2485 1.94434 4.52738V9.44226C1.94417 9.47375 1.9472 9.50551 1.95191 9.53734C1.95275 9.54322 1.95359 9.5491 1.9546 9.5549C1.95931 9.58094 1.96502 9.60698 1.97318 9.63285L3.7604 15.3363C3.84479 15.6057 4.09353 15.7782 4.36185 15.7782C4.42414 15.7782 4.48752 15.7689 4.55015 15.7493L7.15276 14.9361C7.31239 14.8862 7.44563 14.775 7.52313 14.627C7.60072 14.479 7.61619 14.3062 7.56626 14.1467L6.68059 11.3186L10.8382 12.5508V13.1198C10.8382 13.4678 11.1204 13.7498 11.4686 13.7498H14.0917C14.4398 13.7498 14.7221 13.4678 14.7221 13.1198V0.85264C14.7222 0.504721 14.4399 0.222656 14.0917 0.222656ZM6.17463 13.9216L4.77535 14.3588L3.53007 10.3848L5.22423 10.8869L6.17463 13.9216ZM5.90841 9.77556C5.90664 9.77506 5.90479 9.77447 5.90303 9.77396L3.20534 8.97439V4.99768L10.8383 2.73595V11.2367L5.90841 9.77556ZM13.4613 12.4899H12.0992V12.0806V1.89203V1.48271H13.4613V12.4899Z"
                                        fill="#9B9B9B"
                                      />
                                      <path
                                        d="M19.0799 10.4739L16.2306 9.17481C15.9052 9.02664 15.5097 9.14663 15.347 9.44328C15.1843 9.73985 15.3162 10.1005 15.6415 10.2488L18.4908 11.5479C18.5854 11.591 18.6858 11.6113 18.7849 11.6113C19.0264 11.6113 19.259 11.4897 19.3744 11.2794C19.537 10.9828 19.4051 10.6222 19.0799 10.4739Z"
                                        fill="#9B9B9B"
                                      />
                                      <path
                                        d="M15.9365 4.94575C16.0355 4.94575 16.136 4.92307 16.2305 4.87513L19.0798 3.43184C19.4051 3.26702 19.537 2.86642 19.3743 2.53688C19.2117 2.20735 18.8161 2.07375 18.4909 2.23857L15.6415 3.68186C15.3162 3.84667 15.1843 4.24727 15.347 4.57681C15.4624 4.81064 15.695 4.94575 15.9365 4.94575Z"
                                        fill="#9B9B9B"
                                      />
                                      <path
                                        d="M19.3564 6.33398H17.032C16.6767 6.33398 16.3887 6.64491 16.3887 7.02843C16.3887 7.41195 16.6767 7.72287 17.032 7.72287H19.3564C19.7117 7.72287 19.9998 7.41195 19.9998 7.02843C19.9998 6.64482 19.7117 6.33398 19.3564 6.33398Z"
                                        fill="#9B9B9B"
                                      />
                                    </svg>
                                  </div>
                                ),
                              }}
                            />
                          </div>
                        </div>

                        <div className="col-12 col-md-12">
                          <div className="input-container">
                            <>
                              <label htmlFor="timeZoneId">Select Member Status</label>
                              <Select
                                value={selectedOptions?.memberStatus}
                                placeholder={campaignData?.memberStatusId}
                                onChange={(selectedOption) =>
                                  handleChange(selectedOption, 'memberStatusId')
                                }
                                options={memberStatus?.map((data) => ({
                                  value: data.id,
                                  label: data.displayName,
                                }))}
                                styles={{
                                  container: (base) => ({
                                    ...base,
                                    width: '200px',
                                  }),
                                  menu: (base) => ({
                                    ...base,
                                    zIndex: '9999',
                                    height: '200px',
                                    overflow: 'auto',
                                    color: '#000',
                                  }),
                                  control: (base) => ({
                                    ...base,
                                    borderRadius: '50px',
                                  }),
                                }}
                              />
                            </>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer justify-content-end">
                      <button type="button" className="cancel_popup" data-bs-dismiss="modal">
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="save_popup "
                        onClick={() => handleSubmit(campaignData)}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Modal structure Delete */}
            <div id="dropdown_modal">
              <div
                className="modal fade"
                id="delete"
                tabIndex="-1"
                aria-labelledby="modalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="warning-content">
                      <div className="warningOuter">
                        <div className="alertImg">
                          <img src="../assets/images/delete-record.png" alt="Delete Record"></img>
                        </div>
                        <div className="warningText">
                          {' '}
                          Are you sure you want to delete the selected record?
                        </div>
                      </div>
                      <div className="notes">
                        *Note: Any associated Activities, Visits, Drafts will also be Deleted.
                      </div>
                      <div className="warningBtn mt-2">
                        <Button
                          variant="secondary"
                          className="btn"
                          data-bs-dismiss="modal"
                          id="massDeleteModal"
                        >
                          Cancel
                        </Button>
                        <Button className="btn" variant="danger" onClick={handleClickDelete}>
                          Confirm Delete
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ChildTicket
              remindVisible={remindVisible}
              showReminderPage={showReminderPage}
              handleBackClick={handleBackClick}
              togglePopupVisibility={togglePopupVisibility}
              formData={formData}
              handleDateTime={handleDateTime}
              handleChangeForm={handleChangeForm}
              errormsg={errormsg}
              handleChange={handleChange}
              selectedOptions={selectedOptions}
              ticketPriorityDropdown={ticketPriorityDropdown}
              owner={owner}
              ticketStatusDropdown={ticketStatusDropdown}
              handleReminderClick={handleReminderClick}
              loading={loading}
              handleFormSubmit={handleFormSubmit}
            />
            {/* Popup Modal */}
            {showPopup && (
              <div id="genricPopup">
                <div className="popup-overlay">
                  <div className="popup">
                    <div className="popup-header">
                      <h2>{popupAction === 'add' ? 'Add Tags' : 'Remove Tags'}</h2>
                      <button
                        type="button"
                        className="custom-btn-close"
                        aria-label="Close"
                        onClick={togglePopup}
                      ></button>
                    </div>

                    {/* Pass a prop (like `removeMode`) to the Tags component
                        so that it can handle add vs. remove differently */}
                    {popupAction === 'add' ? (
                      <Tags
                        module="Campaign"
                        handleClose={togglePopup}
                        selectedRows={fullSelection}
                        storeKey={'campaignList'}
                      />
                    ) : (
                      <Tags
                        module="Campaign"
                        removeMode={true}
                        handleClose={togglePopup}
                        selectedRows={fullSelection}
                        storeKey={'campaignList'}
                      />
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default Campaigns;
